import { h, Component } from 'preact';
import { MkComponent } from 'lib/mkjs/mkcomponent';
import ContactEntity from "entities/contactentity";

export default class ContactIdentityVerification extends MkComponent {
	getBasePath() {
		return "/contact-identity-verifications"
	}

	getFieldComponent(fieldName) {
		const fieldComponents = {
			entity: this._fieldReference(ContactEntity)
		}
		return fieldComponents[fieldName];
	}

	userCan(action, item) {
		return action == 'create' || this.props.userIsAdmin;
	}
}



// WEBPACK FOOTER //
// ./entities/contactidentityverfication/index.js